import styled from 'styled-components';

import { StatusBanner } from '@xing-com/banner';
import { TextButton } from '@xing-com/button';
import { Divider } from '@xing-com/divider';
import { Label } from '@xing-com/label';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  SkeletonRadioButton,
  SkeletonImage,
  SkeletonBodyCopy,
  SkeletonHeadline,
} from '@xing-com/skeleton';
import {
  spaceXS,
  spaceM,
  spaceXL,
  spaceXXL,
  xdlColorTextSecondary,
  xdlColorBackgroundTertiary,
  spaceL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const StyledLabel = styled(Label)<{ $active?: boolean }>`
  display: flex;
  gap: ${spaceM};
  width: 100%;
  padding: ${spaceM};
  background-color: ${({ $active }) =>
    $active ? xdlColorBackgroundTertiary : 'none'};
`;

export const MobileWrapper = styled.div`
  padding: 0 ${spaceXL} ${spaceXL};
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const OverflowWrapper = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  max-height: calc(100vh - 182px);
`;

export const StyledSubline = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
`;

export const StyledDivider = styled(Divider)`
  margin: ${spaceXL} 0;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    justify-content: space-between;
  } 
`;

export const StyledTextButton = styled(TextButton)`

  @media ${mediaSmallOrTiny} {
    margin: 0 ${spaceL};
  }
`;

export const StyledUploadWrapper = styled.div`
  margin: calc(${spaceXL} + ${spaceM}) 0 calc(${spaceXL} + ${spaceM}) 0;
  position: relative;
  overflow: hidden;

  @media ${mediaSmallOrTiny} {
    margin: calc(${spaceXS} + ${spaceM}) 0 calc(${spaceXS} + ${spaceM}) 0;
  } 
`;

export const StyledSkeletonWrapper = styled.div`
  width: 100%;
`;

export const StyledSkeletonRadioButton = styled(SkeletonRadioButton)`
  flex-shrink: 0;
`;

export const StyledSkeletonImage = styled(SkeletonImage)`
  flex-shrink: 0;
`;

export const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  width: 60%;
  margin-bottom: 9px;
`;

export const StyledSkeletonBodyCopy = styled(SkeletonBodyCopy)`
  width: 50%;
`;

export const StyledStatusBanner = styled(StatusBanner)`
  margin-bottom: ${spaceM};
`;

export const StyledMultiselectCopy = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
`;
